<template>
    <div class="container mainContent">
        <div>
            <form>
                <div class="form-group">
                    <div>
                        <h2 class="mb-4">สมัครกิจกรรม</h2>
                        <!-- <h4>พบกันเร็วๆนี้</h4> -->
                    </div>
                    <div>
                      <div class="row">
                          <div class="col-12 text-left">
                              <h4 class="mb-3">ข้อมูลกิจกรรม</h4>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-lg-10 col-12">
                              <select required v-model="select_faculty" class="custom-select">
                                  <option disabled selected value="-1">-- เลือกคณะ --</option>
                                  <option value="CEN">กิจกรรมเวทีกลาง</option>
                                  <option value="EN">คณะวิศวกรรมศาสตร์</option>
                                  <option value="ARCH">คณะสถาปัตยกรรมศาสตร์</option>
                                  <option value="IETECH">คณะครุศาสตร์อุตสาหกรรม</option>
                                  <option value="AGRO">คณะอุตสาหกรรมการเกษตร</option>
                                  <option value="AGRI">คณะเทคโนโลยีการเกษตร</option>
                                  <option value="SCI">คณะวิทยาศาสตร์</option>
                                  <option value="IT">คณะเทคโนโลยีสารสนเทศ</option>
                                  <!-- <option value="FAM">คณะการบริหารและการจัดการ</option> -->
                                  <option value="LA">คณะศิลปศาสตร์</option>
                                  <!-- <option value="MED">คณะแพทยศาสตร์</option> -->
                                  <option value="NANO">วิทยาลัยนาโนเทคโนโลยี</option>
                                  <option value="AMI">วิทยาลัยนวัตกรรมการผลิตขั้นสูง</option>
                                  <option value="MUSIC">วิทยาลัยวิศวกรรมสังคีต</option>
                                  <option value="AEC">วิทยาลัยอุตสาหกรรมการบินนานาชาติ</option>
                                  <option value="CHUMPHON">วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร</option>
                              </select>
                          </div>
                          <div class="col-lg-2 col-12 text-left">
                              <a class="btn btn-primary mb-2 w-100" @click="submit_faculty" :disabled="this.select_faculty == -1">ค้นหา</a>
                          </div>
                      </div>
                      <div class="table-responsive">
                          <table class="table table-striped">
                              <thead class="thead-dark">
                                  <tr>
                                      <th scope="col">วันที่</th>
                                      <th scope="col">กิจกรรม</th>
                                      <th scope="col">สถานที่</th>
                                      <th scope="col">เวลา</th>
                                      <th scope="col">จำนวนที่รับ</th>
                                      <th class="description" scope="col">รายละเอียด</th>
                                      <th scope="col">สมัคร</th>
                                  </tr>
                              </thead>

                              <tbody v-if="showTable == 'haveWorkshop' && this.select_faculty !='SCI' && this.select_faculty !='IT'">
                                  <tr v-for="(value, index) in table_Compronent_23" v-bind:key="value.id">
                                      <td scope="col"> {{ value.date + " สิงหาคม 2562"}} </td>
                                      <td scope="col"> {{ value.name }} </td>
                                      <td scope="col"> {{ value.place }} </td>
                                      <td scope="col"> {{ value.time }} </td>
                                      <td scope="col" v-if="value.maxAmount == 'unlimited'"> ไม่จำกัดจำนวน </td>
                                      <td scope="col" v-if="value.maxAmount != 'unlimited'"> {{value.currentAmount}}/{{value.maxAmount}} </td>
                                      <td class="description" scope="col"> {{ value.description }} </td>
                                      <td v-show="value.id != 'ARCH05' && value.id != 'ARCH06' && value.id != 'ARCH29' && value.id != 'ARCH30'"><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)">สมัคร</a></td>
                                      <td v-show="value.id == 'ARCH05' && value.id == 'ARCH06' && value.id == 'ARCH29' && value.id == 'ARCH30'"><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)"></a></td>
                                  </tr>
                              </tbody>
                              <tbody v-if="showTable == 'haveWorkshop' && this.select_faculty !='SCI' && this.select_faculty !='IT'">
                                  <tr v-for="(value, index) in table_Compronent_24" v-bind:key="value.id">
                                      <td scope="col"> {{ value.date + " สิงหาคม 2562"}} </td>
                                      <td scope="col"> {{ value.name }} </td>
                                      <td scope="col"> {{ value.place }} </td>
                                      <td scope="col"> {{ value.time }} </td>
                                      <td scope="col" v-if="value.maxAmount == 'unlimited'"> ไม่จำกัดจำนวน </td>
                                      <td scope="col" v-if="value.maxAmount != 'unlimited'"> {{value.currentAmount}}/{{value.maxAmount}} </td>
                                      <td class="description" scope="col"> {{ value.description }} </td>
                                      <td v-show="value.id != 'ARCH05' && value.id != 'ARCH06' && value.id != 'ARCH29' && value.id != 'ARCH30'"><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)">สมัคร</a></td>
                                      <td v-show="value.id == 'ARCH05' && value.id == 'ARCH06' && value.id == 'ARCH29' && value.id == 'ARCH30'"><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)"></a></td>
                                  </tr>
                              </tbody>

                              <tbody v-if="this.select_faculty == 'SCI'">
                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> หลักสูตรคณิตศาสตร์สร้างพลังความคิดและกิจกรรมที่ใช้สื่อการสอนเน้นความเข้าใจ </td>
                                      <td scope="col"> ณ อาคารจุฬาภรณวลัยลักษณ์ 1 ห้อง 612  </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> 30 </td>
                                      <td class="description" scope="col"> ขอสงวนลิขสิทธิ์สำรองที่นั่งแต่ละหัวข้อสำหรับหน่วยงานละ 2 ท่านลงทะเบียนสำรองที่นั่ง ได้ตั้งแต่บัดนี้ หรือจนกว่าจะครบจำนวน รับสมัครจำนวนจำกัดหลักสูตรละ 30 ท่าน </td>
                                      <td><a class="btn btn-primary" href="https://docs.google.com/forms/d/e/1FAIpQLSc8Fy1Ui3ImxIGVa_hiejhJjdHG8XgLd9mLqYXLI79h9oqwew/viewform">สมัคร</a></td>
                                  </tr>

                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> หลักสูตรระบบเก็บข้อมูลอัตโนมัติกับการวัดปริมาณทางวิทยาศาสตร์ </td>
                                      <td scope="col"> ณ อาคารจุฬาภรณวลัยลักษณ์ 1 ห้อง 611  </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> 30 </td>
                                      <td class="description" scope="col"> ขอสงวนลิขสิทธิ์สำรองที่นั่งแต่ละหัวข้อสำหรับหน่วยงานละ 2 ท่านลงทะเบียนสำรองที่นั่ง ได้ตั้งแต่บัดนี้ หรือจนกว่าจะครบจำนวน รับสมัครจำนวนจำกัดหลักสูตรละ 30 ท่าน </td>
                                      <td><a class="btn btn-primary" href="https://docs.google.com/forms/d/e/1FAIpQLSc_-V0GCPdmNWdO5AoZtv2DilvyMnJ4vhUrQfv_m04ScjCizg/viewform">สมัคร</a></td>
                                  </tr>
                              </tbody>

                              <tbody v-if="this.select_faculty == 'IT' && this.isSummit">
                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> Joy Story จินตนาการทะลุมิติ กับ Animation และ AR </td>
                                      <td scope="col"> ณ อาคารเทคโนโลยีสารสนเทศ ชั้น 1 ห้อง M04  </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> ไม่จำกัดจำนวน </td>
                                      <td class="description" scope="col"> พบกับ workshop ทางด้านสื่อประสม (Multimedia) ที่เปิดโอกาสให้น้องๆ ได้เรียนรู้และทดลองสร้าง 3D model พร้อมออกแบบสี ลักษณะพื้นผิว และการเคลื่อนไหวด้วยตัวเอง เพื่อนำไปใช้งานกับเทคโนโลยี AR (Augmented Reality) ด้วยการเขียนโปรแกรมควบคุมการเคลื่อนไหวของตัวละครผ่านเครื่องมือพื้นฐานที่สามารถนำไปต่อยอดได้ด้วยตัวเอง 
                                        <ul>
                                          <li>วันที่ 23 เวลา 13.30 – 14.30 น. </li>
                                          <li>วันที่ 24 เวลา 09.30 – 10.30 น. เเละ 13.30 – 14.30 น.</li>
                                          <li>ลงทะเบียนหน้างาน ณ อาคารเทคโนโลยีสารสนเทศ</li>
                                        </ul>
                                      </td>
                                      <td><a class="btn btn-primary" href="https://openhouse.it.kmitl.ac.th">เว็บไซต์</a></td>
                                  </tr>

                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> เชื่อมต่อทุกสิ่งด้วย IoT </td>
                                      <td scope="col"> ณ อาคารเทคโนโลยีสารสนเทศ ชั้น 1 ห้อง M21 </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> ไม่จำกัดจำนวน </td>
                                      <td class="description" scope="col"> workshop ทางด้านเครือข่าย (Networks) เปิดโอกาสให้น้องๆ เรียนรู้กับเทคโนโลยีสุดชิคในตอนนี้อย่าง IoT (Internet of Things) โดยให้น้องๆ จะได้ลองเชื่อมต่อสิ่งต่างๆ เข้ากับ Internet ผ่านระบบคลาวด์ (Cloud) ที่สามารถตรวจสอบหรือแจ้งเตือน ผ่านเครื่องคอมพิวเตอร์ มือถือ หรือแทปเล็ตได้ทุกที่ผ่านทาง Internet ซึ่งจะทำให้น้องๆ เข้าใจพื้นฐานการทำงานของของเทคโนโลยี IoT พบเห็นได้ในปัจจุบัน เช่น Smart home, Smart farm, Healthcare monitoring เป็นต้น 
                                        <ul>
                                          <li>วันที่ 23 เวลา 13.30 – 14.30 น. </li>
                                          <li>วันที่ 24 เวลา 09.30 – 10.30 น. เเละ 13.30 – 14.30 น.</li>
                                          <li>ลงทะเบียนหน้างาน ณ อาคารเทคโนโลยีสารสนเทศ</li>
                                        </ul>
                                      </td>
                                      <td><a class="btn btn-primary" href="https://openhouse.it.kmitl.ac.th">เว็บไซต์</a></td>
                                  </tr>

                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> What can a robot do? ควบคุมหุ่นยนต์จิ๋วด้วยบล็อคโค้ด </td>
                                      <td scope="col"> ณ อาคารเทคโนโลยีสารสนเทศ ชั้น 1 ห้อง M22  </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> ไม่จำกัดจำนวน </td>
                                      <td class="description" scope="col"> workshop ทางด้านวิศวกรรมซอฟต์แวร์ (Software Engineering) ที่ท้าทายความสามารถของน้องๆ ในการควบคุมหุ่นจิ๋ว ผ่านการเขียนโปรแกรมควบคุมหุ่นยนต์ด้วยบล็อคโค้ด และพบกับลูกเล่นมากมายที่มากมายที่มาพร้อมกับหุ่น Micro รุ่น Maqueen อาทิ เซ็นเซอร์อัลตราโซนิค เซ็นเซอร์เคลื่อนที่ตามเส้น การรับข้อมูลจากสภาพแวดล้อม และอีกมากมาย 
                                        <ul>
                                          <li>วันที่ 23 เวลา 13.30 – 14.30 น. </li>
                                          <li>วันที่ 24 เวลา 09.30 – 10.30 น. เเละ 13.30 – 14.30 น.</li>
                                          <li>ลงทะเบียนหน้างาน ณ อาคารเทคโนโลยีสารสนเทศ</li>
                                        </ul>
                                      </td>
                                      <td><a class="btn btn-primary" href="https://openhouse.it.kmitl.ac.th">เว็บไซต์</a></td>
                                  </tr>

                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> Ez Data Science </td>
                                      <td scope="col"> ณ อาคารเทคโนโลยีสารสนเทศ ชั้น 1 ห้อง M03  </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> ไม่จำกัดจำนวน </td>
                                      <td class="description" scope="col"> workshop ทางด้านวิทยาการข้อมูล (Data Science) ถือเป็นสาขาวิชาที่มาแรงสุดๆ ในขณะนี้ สัมผัสกับ workshop ที่จะปลุกความเป็นนักวิทยาการข้อมูลในตัวเองขึ้นมา กับการถ่ายกระบวนการในการจัดการกับข้อมูลจำนวนมากที่อยู่รอบตัว ด้วยการรวบรวม สร้าง และวิเคราะห์ข้อมูล จนไปถึงเรียนรู้วิธีการพยากรณ์สิ่งต่างๆ จากข้อมูล สัมผัสกับสิ่งเหล่านี้ พร้อมไขข้อสงสัย วิทยาการข้อมูลสำคัญอย่างไร..ทำไมองค์กรธุรกิจถึงต้องการตัว 
                                        <ul>
                                          <li>วันที่ 23 เวลา 13.30 – 14.30 น. </li>
                                          <li>วันที่ 24 เวลา 09.30 – 10.30 น. เเละ 13.30 – 14.30 น.</li>
                                          <li>ลงทะเบียนหน้างาน ณ อาคารเทคโนโลยีสารสนเทศ</li>
                                        </ul>
                                      </td>
                                      <td><a class="btn btn-primary" href="https://openhouse.it.kmitl.ac.th">เว็บไซต์</a></td>
                                  </tr>

                                  <tr>
                                      <td scope="col"> 23 สิงหาคม 2562 - 24 สิงหาคม 2562 </td>
                                      <td scope="col"> Build your iOS App </td>
                                      <td scope="col"> ณ อาคารเทคโนโลยีสารสนเทศ ชั้น 3 ห้อง M308 </td>
                                      <td scope="col"> 09.00-16.00 น. </td>
                                      <td scope="col"> ไม่จำกัดจำนวน </td>
                                      <td class="description" scope="col"> Workshop พิเศษ “Build your iOS App” การอบรมการเขียน App ด้วย iOS ที่จะพาน้องๆ ไปทดลองทำ application เพื่อใช้งานบนระบบปฏิบัติการ iOS ที่ใช้บน iPhone ด้วยตัวเอง พบกับการเรียนรู้ทั้งทฤษฏีและปฏิบัติ ที่จะทำให้น้องๆ ได้รู้และเข้าใจพื้นฐานการทำงานของส่วนประกอบของต่างๆ ของ application ในเบื้องต้นว่ามีอะไรบ้าง ทำงานร่วมกันได้อย่างไร 
                                        <ul>
                                          <li>วันที่ 23 เวลา 13.30 – 14.30 น. </li>
                                          <li>วันที่ 24 เวลา 09.30 – 10.30 น. เเละ 13.30 – 14.30 น.</li>
                                          <li>ลงทะเบียนหน้างาน ณ อาคารเทคโนโลยีสารสนเทศ</li>
                                        </ul>
                                      </td>
                                      <td><a class="btn btn-primary" href="https://openhouse.it.kmitl.ac.th">เว็บไซต์</a></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                    
                    </div>
                </div>
            </form>
        </div>

        <div v-if="showModal">
            <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">

                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title req-field">เเจ้งเตือน</h5>
                            <button  class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="showModal = false">&times;</span>
                            </button>
                        </div>
                        <div v-if="alertOnly" class="modal-body">
                            <p>{{ modalmsg }}</p>
                        </div>
                        <div v-if="this.onSureFooter == true" class="modal-body text-left">
                            <p>{{ modalmsg }}</p>
                            <div class="row ">
                                <div class="col-12">ชื่อกิจกรรม: {{selectEventName}}</div>
                                <div class="col-12">วันที่: {{selectEventDate}} สิงหาคม 2562</div>
                                <div class="col-12">เวลา: {{selectEventTime}}</div>
                                <div class="col-12 mb-2">สถานที่: {{selectEventPlace}}</div>
                            </div>
                        </div>
                        <div v-if="this.onSureFooter == true" class="modal-footer">
                            <a @click="onSubmit(selectEventEid)" class="btn btn-primary">ลงทะเบียน</a>
                        </div>
                    </div>
                </div>

                </div>
            </div>
            </transition>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { mapGetters } from 'vuex';

Vue.use(BootstrapVue)
export default {
  name: 'Workshop',
  data: () => {
    return {
        select_faculty: -1,
        faculty_workshop: null,
        table_Compronent_23: null,
        table_Compronent_24: null,
        key: null,
        submit: null,
        token: null,
        username: "Guest",
        showModal: false,
        modalmsg: "",
        showTable: false,
        facultyTh: null,
        onSureFooter: false,
        alertOnly: false,
        checkClick: false,
        selectEventEid: null,
        selectEventName: null,
        selectEventDate: null,
        selectEventTime: null,
        selectEventPlace: null,
        selectEventMaxAmount: null,
        isSummit: false
    }
  },
  methods: {
    ...mapGetters([
      'getUsername',
      'getToken',
      'getLoginState'
    ]),
    getUserProfile() {
      this.username = this.getUsername()
    },
    submit_faculty() {
      if (this.select_faculty == "CEN") {
        this.facultyTh = "กิจกรรมเวทีกลาง"
      } else if (this.select_faculty == "EN") {
        this.facultyTh = "คณะวิศวกรรมศาสตร์"
      } else if (this.select_faculty == "IETECH") {
        this.facultyTh = "คณะครุศาสตร์อุตสาหกรรม"
      } else if (this.select_faculty == "AGRO") {
        this.facultyTh = "คณะอุตสาหกรรมการเกษตร"
      } else if (this.select_faculty == "AGRI") {
        this.facultyTh = "คณะเทคโนโลยีการเกษตร"
      } else if (this.select_faculty == "SCI") {
        this.facultyTh = "คณะวิทยาศาสตร์"
      } else if (this.select_faculty == "IT") {
        this.facultyTh = "คณะเทคโนโลยีสารสนเทศ"
      } else if (this.select_faculty == "FAM") {
        this.facultyTh = "คณะการบริหารและการจัดการ"
      } else if (this.select_faculty == "LA") {
        this.facultyTh = "คณะศิลปศาสตร์"
      } else if (this.select_faculty == "NANO") {
        this.facultyTh = "วิทยาลัยนาโนเทคโนโลยี"
      } else if (this.select_faculty == "AMI") {
        this.facultyTh = "วิทยาลัยนวัตกรรมการผลิตขั้นสูง"
      } else if (this.select_faculty == "MUSIC") {
        this.facultyTh = "วิทยาลัยวิศวกรรมสังคีต"
      } else if (this.select_faculty == "AEC") {
        this.facultyTh = "วิทยาลัยอุตสาหกรรมการบินนานาชาติ"
      } else if (this.select_faculty == "CHUMPHON") {
        this.facultyTh = "วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร"
      } else if (this.select_faculty == "MED") {
        this.facultyTh = "คณะแพทยศาสตร์"
      }
      this.isSummit = true
      this.showModal = true
      this.onSureFooter = false
      this.alertOnly = true
      this.modalmsg = 'กรุณารอซักครู่'
      if (this.select_faculty == -1) {
        this.showModal = true
        this.alertOnly = true
        this.modalmsg = 'กรุณาเลือกคณะ'
        return false
      } else {
        axios.get(
          "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/getEventByFaculty",
          {headers: {
            "faculty": this.select_faculty
            }
          }
        )
        .then((res) => {
          this.showModal = false
          this.alertOnly = false
          this.onSureFooter = false
          // console.log(res.data)
        //  console.log(Object.keys(res.data).length);
          if (Object.keys(res.data).length != 0) {
                var ordered_23 = {};
                var ordered_24 = {};
                Object.keys(res.data).sort().forEach(function(key) {
                  if (res.data[key].date == "23") {
                    ordered_23[key] = res.data[key]
                  } else {
                    ordered_24[key] = res.data[key]
                  }
                    
                })
                this.table_Compronent_23 = ordered_23
                this.table_Compronent_24 = ordered_24
                this.showTable = "haveWorkshop"
                

                if ( this.select_faculty == 'IT' || this.select_faculty == 'SCI' ) {
                  this.isSummit = true
                } else {
                  this.isSummit = false
                }
                
                
          } else if (Object.keys(res.data).length == 0) {
              this.showTable = "dontHaveWorkshop"
              if ( this.select_faculty == 'IT' || this.select_faculty == 'SCI' ) {
                  this.isSummit = true
              } else {
                  this.isSummit = false
              }
          }
          
        })
        .catch((err) => {
          // console.log(err)
        })
      }
    },
    async onSubmit(eid) {
        if (this.select_faculty == "CEN") {
          this.showModal = true
          this.onSureFooter = false
          this.alertOnly = true
          this.modalmsg = "เนื่องจากมีผู้ลงสมัครกิจกรรมเวทีกลางล่วงหน้าเป็นจำนวนมาก จึงขอปิดระบบสมัครกิจกรรมล่วงหน้า สำหรับกิจกรรมของเวทีกลาง ผู้ที่สนใจเข้าร่วมกิจกรรมยังสามารถเข้าร่วมกิจกรรมได้ในวันงานจริง ขออภัยอย่างสูงมา ณ ที่นี้"
          return ""
        } else if (this.select_faculty == "EN") {
          this.showModal = true
          this.onSureFooter = false
          this.alertOnly = true
          this.modalmsg = "เนื่องจากมีผู้ลงสมัครกิจกรรมคณะวิศวกรรมศาสตร์ล่วงหน้าเป็นจำนวนมาก จึงขอปิดระบบสมัครกิจกรรมล่วงหน้า สำหรับกิจกรรมของคณะวิศวกรรมศาสตร์ ผู้ที่สนใจเข้าร่วมกิจกรรมยังสามารถเข้าร่วมกิจกรรมได้ในวันงานจริง ขออภัยอย่างสูงมา ณ ที่นี้"
          return ""
        }
        this.onSureFooter = false
        this.showModal = true
        this.alertOnly = true
        this.modalmsg = "กรุณารอซักครู่ระบบกำลังลงสมัครกิจกรรมให้คุณ"
      axios({
          method: "POST",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/register",
          headers: {
            "Authorization": "Bearer " + this.getToken(),
            "Content-Type": "application/json"
          },
          data: {
            "faculty": this.select_faculty,
            "eventId": eid
          }
      })
      .then((res) => {
        // console.log(res)
        if (res.data == "Registered") {
            this.$router.push('/dashboard')
        } else if (res.data == "User Exceed Maximum User") {
             this.showModal = true
             this.onSureFooter = false
             this.alertOnly = true
             this.modalmsg = "ขออภัย กิจกรรมนี้มีคนลงสมัครครบเเล้ว"
        } else if (res.data == "Already Registered") {
             this.showModal = true
             this.alertOnly = true
             this.onSureFooter = false
             this.modalmsg = "คุณได้ลงสมัครกิจกรรมนี้เเล้ว"
        }
      })
      .catch((err) => {
        this.showModal = true
        this.onSureFooter = false
        this.modalmsg = "ขออภัย กรุณาสมัครกิจกรรมใหม่"
      })
    },
    onSure(eid, name, date, time, place, maxAmount) {
        this.onSureFooter = true
        this.showModal = true
        this.alertOnly = false
        this.modalmsg = "คุณยืนยันที่จะลงกิจกรรม"
        this.selectEventEid = eid
        this.selectEventName = name
        this.selectEventDate = date
        this.selectEventTime = time
        this.selectEventPlace = place
        this.selectEventMaxAmount = maxAmount
    }
  },
  // mounted () {
  //   if (this.getLoginState() === false) {
  //     this.$router.push('/login')
  //   }
  // }
}

</script>

<style lang="scss" scoped>

.modal-title {
    color: #ee4b23;
}

select.custom-select {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    margin-bottom: 1em;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}

td, th {
    text-align: justify;
}

.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {
  color: rgba(255,255,255,.5);
  text-decoration: none;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .9s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.mainContent {
  min-height: calc(100vh - 322px) ;
}

@media screen and (max-width: 568px) {
	.description {
    display: none;
  }
}
</style>
